<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Integração</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('integracao.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('integracao.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('integracao.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/integracao"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="integracao_id"
                                            pagination-path=""
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:cell-clicked="onDetail"
                                            detail-row-component="integracao-detalhes"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                            </template>
                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-if="getPermission('integracao.update')" v-b-tooltip title="Editar"><i class="fa fa-edit"></i></a>
                                                <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <IntegracaoForm ref="integracaoform" />
    </div>
</div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import IntegracaoFilterBar from './IntegracaoFilterBar'
import IntegracaoDetalhes from './IntegracaoDetalhes.vue'
import IntegracaoForm from './IntegracaoForm'
import moment from 'moment'

Vue.component('integracao-detalhes', IntegracaoDetalhes);

export default {
    components: {
        Vuetable,
        IntegracaoDetalhes,
        VuetablePagination,
        VuetablePaginationInfo,
        IntegracaoForm,
        'vuetable-filterbar': IntegracaoFilterBar,
    },
    data () {
      return {
        date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalDoc: false,
        showModalConta: false,
        isFullscreen: false,
        optionsLayout: [],
        optionsStatus: [],
        optionsTpAuth: [],
        optionsTpEntidade: [],
        optionsTpEnvio: [],
        optionsTpFluxo: [],
        optionsTpFormato: [],
        optionsTpIntegracao: [],
        optionsTpTrigger: [],
        optionsUnidade: [],
        optionsConfigFtp: [],
        helpForm: new Form({recordCollection: [], status:''}),
        fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
                name: 'cd',
                title: 'Código',
                sortField: 'cd'
            },
            {
                name: 'descr',
                title: 'Descrição',
                sortField: 'descr'
            },
            {
                name: 'tp_fluxo.descr',
                title: 'Tipo Fluxo',
                sortField: 'tp_fluxo'
            },
            {
                name: 'tp_integracao.descr',
                title: 'Tipo Integração',
                sortField: 'tp_integracao'
            },
            {
                name: 'tp_entidade.descr',
                title: 'Tipo Entidade',
                sortField: 'tp_entidade'
            },
            {
                name: 'tp_trigger.descr',
                title: 'Tipo Trigger',
                sortField: 'tp_trigger'
            },
            {
                name: 'tp_formato.descr',
                title: 'Tipo Formato',
                sortField: 'tp_formato'
            },
            {
                name: 'tp_envio.descr',
                title: 'Tipo Envio',
                sortField: 'tp_envio'
            },
            {
                name: 'tp_auth.descr',
                title: 'Tipo Auth',
                sortField: 'tp_auth'
            },
            {
                name: '__slot:status',
                title: 'Status',
                sortField: 'status'
            },
            {
                name: '__slot:actions',   // <----
                title: 'Ações',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {}
       }

    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    created() {
        let self = this;
        Event.$on('reloadVuetable', function (data) {
            self.onReloadVuetable();
        });

    },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'cd': data_filter.cd,
                'descr': data_filter.descr,
                'cnpj': data_filter.cnpj,
                'razao_social': data_filter.razao_social,
                'tp_unidade': data_filter.tp_unidade.value,
                'status': data_filter.status.value,
                'tipo_doc': data_filter.tipo_doc.value,
                'municipio': data_filter.municipio.value
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            // Havia um console.log(data) aqui, que despejava a linha inteira da
            // integração no console do navegador. Hoje o backend já não devolve
            // credencial no GET, então nada vazava — mas a linha voltaria a
            // vazar sozinha no dia em que algum campo sensível retornasse.
            this.$refs.vuetable.toggleDetailRow(data.integracao_id);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        DateFormat: function(date) {
          if(date != null){
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
          return "";
        },
        onCreate () {
            this.$refs.integracaoform.onCreate();
        },
        onEdit (data, index) {
            this.$refs.integracaoform.onEdit(data);
        },
        onReloadVuetable() {
            this.$refs.vuetable.reload();
        },
        getLivGeral() {
            this.helpForm.get('/api/integracao/jsonlistgeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);

                response.layout.forEach((obj)=>{
                    this.optionsLayout.push({ label: obj.descr, value: obj.lay_id })
                }),
                response.status.forEach((obj)=>{
                    this.optionsStatus.push({ label: obj.descr, value:obj.valor })
                }),
                response.tp_auth.forEach((obj)=>{
                    this.optionsTpAuth.push({ text: obj.descr, value: obj.valor })
                }),
                response.tp_entidade.forEach((obj)=>{
                    this.optionsTpEntidade.push({ text: obj.descr, value: obj.valor })
                }),
                response.tp_envio.forEach((obj)=>{
                    this.optionsTpEnvio.push({ label: obj.descr, value: obj.valor })
                }),
                response.tp_fluxo.forEach((obj)=>{
                    this.optionsTpFluxo.push({ text: obj.descr, value: obj.valor })
                }),
                response.tp_formato.forEach((obj)=>{
                    this.optionsTpFormato.push({ label: obj.descr, value: obj.valor })
                }),
                response.tp_integracao.forEach((obj)=>{
                    this.optionsTpIntegracao.push({ label: obj.descr, value: obj.valor })
                }),
                response.tp_trigger.forEach((obj)=>{
                    this.optionsTpTrigger.push({ text: obj.descr, value: obj.valor })
                }),
                response.unidade.forEach((obj)=>{
                    this.optionsUnidade.push({ label: obj.descr, unidade_id: obj.unidade_id, status: 1 })
                }),
                response.config_ftp.forEach((obj)=>{
                    this.optionsConfigFtp.push({ label: obj.descr, value: obj.conftp_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        onActivateDesactivate(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {
                this.helpForm.recordCollection = [];
                this.helpForm.recordCollection.push(data.integracao_id);
            }
            else
            {
                this.helpForm.recordCollection = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.recordCollection.push(obj)
                });
            }
            this.$refs.integracaoform.onActivateDesactivate(this.helpForm);
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        user: {
            get() {
                return this.$store.state.logged.user;
            }
        },
        b_plano: {
            get() {
                return this.$store.getters.bplano;
            }
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
<style>
    .form-check{
        padding: 0 1.25rem;
    }
</style>
